import { withTranslation } from "@template/components/translation";
import styles from "./NoisyText.css";
import PropTypes from "prop-types";

const NoisyText = ({ formatTranslation }) => {
  const accessibleText = formatTranslation(
    "alt_marketing_compliant_quick_join_overlay_title_web_accessible"
  );
  const visualText = formatTranslation(
    "alt_marketing_compliant_quick_join_overlay_title_web"
  );

  return (
    <div className={styles.container} aria-label={accessibleText}>
      {visualText.split("\n").map((text, i) => (
        <span key={i} className={styles.noisyText} aria-hidden="true">
          {text.trim()}
        </span>
      ))}
    </div>
  );
};

NoisyText.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(NoisyText);
